import type { RouteRecordRaw } from 'vue-router';

export const orderRoutes: Array<RouteRecordRaw> = [
  {
    path: '/order',
    name: 'order',
    redirect: '/order/list',
    component: () => import('pages/trade/admin/order/McOrder.vue'),
    meta: {
      title: 'Trading Activities - Orders',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'orderList',
        component: () => import('pages/trade/admin/order/OrderList.vue'),
        meta: {
          title: 'Orders List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail',
        name: 'orderDetail',
        component: () => import('pages/trade/admin/order/OrderDetail.vue'),
        meta: {
          title: 'Order Details',
          requiresAuth: true,
          // /:itemId?/:folderId?
        },
      },
      {
        path: 'shipping/:itemId?',
        name: 'orderShipping',
        component: () => import('pages/trade/admin/order/OrderShipping.vue'),
        meta: {
          title: 'Order Shipping Details',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'orderExplorer',
        component: () => import('pages/trade/admin/order/OrderExplorer.vue'),
        meta: {
          title: 'Orders Explorer',
          requiresAuth: true,
        },
      },
      {
        path: 'prepare/:folderId?',
        name: 'prepareOrder',
        component: () => import('pages/trade/admin/order/PrepareOrder.vue'),
        meta: {
          title: 'Prepare Order',
          requiresAuth: true,
        },
      },
      {
        path: 'process/:folderId?',
        name: 'processOrder',
        component: () => import('pages/trade/admin/order/ProcessOrder.vue'),
        meta: {
          title: 'Process Order',
          requiresAuth: true,
        },
      },
      {
        path: 'change',
        name: 'orderChange',
        component: () => import('pages/trade/admin/order/OrderChange.vue'),
        meta: {
          title: 'Order Change Tasks - Cancel Order, Cancel Items, Return Items, Exchange Items',
          requiresAuth: true,
        },
      },
      {
        path: 'message',
        name: 'orderMessage',
        redirect: '/order/message/list',
        component: () => import('pages/trade/admin/order/message/McMessage.vue'),
        meta: {
          title: 'Order-Task Messages',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'orderMessageList',
            component: () => import('pages/trade/admin/order/message/MessageList.vue'),
            meta: {
              title: 'Order-Task Messages List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'orderMessageDetail',
            component: () => import('pages/trade/admin/order/message/MessageDetail.vue'),
            meta: {
              title: 'Order-Task Message Details',
              requiresAuth: true,
            },
          },
        ],
      },
    ],
  },
];
